import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Remove = forwardRef<SVGSVGElement | null, IconFilledProps>(function Remove({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M16.4498 12.75C16.7259 12.75 16.9498 12.5262 16.9498 12.25L16.9498 11.75C16.9498 11.4739 16.7259 11.25 16.4498 11.25H7.55029C7.27415 11.25 7.05029 11.4739 7.05029 11.75V12.25C7.05029 12.5262 7.27415 12.75 7.55029 12.75H16.4498Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.0711 19.0711C15.1658 22.9763 8.83418 22.9763 4.92893 19.0711C1.02369 15.1658 1.02369 8.83418 4.92893 4.92893C8.83418 1.02369 15.1658 1.02369 19.0711 4.92893C22.9763 8.83418 22.9763 15.1658 19.0711 19.0711ZM18.0104 18.0104C14.691 21.3299 9.30905 21.3299 5.98959 18.0104C2.67014 14.691 2.67014 9.30905 5.98959 5.98959C9.30905 2.67014 14.691 2.67014 18.0104 5.98959C21.3299 9.30905 21.3299 14.691 18.0104 18.0104Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.0711 19.0711C15.1658 22.9763 8.83418 22.9763 4.92893 19.0711C1.02369 15.1658 1.02369 8.83418 4.92893 4.92893C8.83418 1.02369 15.1658 1.02369 19.0711 4.92893C22.9763 8.83418 22.9763 15.1658 19.0711 19.0711ZM7.55029 12.75C7.27415 12.75 7.05029 12.5262 7.05029 12.25V11.75C7.05029 11.4739 7.27415 11.25 7.55029 11.25L16.4498 11.25C16.7259 11.25 16.9498 11.4739 16.9498 11.75L16.9498 12.25C16.9498 12.5262 16.7259 12.75 16.4498 12.75H7.55029Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'remove-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Remove;
